import { render, staticRenderFns } from "./CmsTypeSchemaForm.vue?vue&type=template&id=4163f15a&scoped=true&"
import script from "./CmsTypeSchemaForm.vue?vue&type=script&lang=js&"
export * from "./CmsTypeSchemaForm.vue?vue&type=script&lang=js&"
import style0 from "./CmsTypeSchemaForm.vue?vue&type=style&index=0&id=4163f15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163f15a",
  null
  
)

export default component.exports